import Axios from 'axios'
import NProgress from 'nprogress'
import QueryString from 'qs'
import _ from 'lodash'

const agent = Axios.create({
  baseURL: '/api/2',
  paramsSerializer: (params) => {
    return QueryString.stringify(params)
  }
})

agent.interceptors.request.use(config => {
  NProgress.start()
  return config
})

agent.interceptors.response.use(response => {
  NProgress.done()
  return response
}, error => {
  NProgress.done()
  return Promise.reject(error)
})

const methodHeaders = function (headers, methodOverride) {
  if (headers == null) {
    headers = {}
  } else {
    headers = _.cloneDeep(headers)
  }
  if (methodOverride != null) {
    headers['X-HTTP-Method-Override'] = methodOverride
  }
  return headers
}

export default {
  get: (path, parameters, headers) => {
    if (parameters == null) {
      parameters = {}
    }
    parameters['_'] = new Date().getTime()
    console.log('get', path, parameters)
    return agent.get(path, {params: parameters, headers: headers})
  },
  delete: (path, headers) => {
    return agent.post(path, {}, {headers: methodHeaders(headers, 'DELETE')})
  },
  put: (path, params, headers) => {
    return agent.post(path, params, {headers: methodHeaders(headers, 'PUT')})
  },
  post: (path, params, headers, options) => {
    if (options == null) {
      options = {}
    }
    options.headers = headers
    return agent.post(path, params, options)
  },
  postRaw: (path, params, headers) => {
    if (headers == null) {
      headers = {}
    }
    headers['Content-Type'] = 'application/x-www-form-urlencoded'
    return agent.post(path, QueryString.stringify(params), {headers: headers})
  }
}



// WEBPACK FOOTER //
// ./src/lib/api/index.js